import { useEffect, useRef, useState } from "react";
import { useInView, animate } from "framer-motion";

export default function AnimatedCounter({
    to = 100,
    duration = 2,
    prefix = "",
    suffix = "",
    className = "",
    testId,
}) {
    const ref = useRef(null);
    const inView = useInView(ref, { once: true, margin: "-50px" });
    const [val, setVal] = useState(0);

    useEffect(() => {
        if (!inView) return;
        const controls = animate(0, to, {
            duration,
            ease: [0.16, 1, 0.3, 1],
            onUpdate(v) {
                setVal(Math.floor(v));
            },
        });
        return () => controls.stop();
    }, [inView, to, duration]);

    return (
        <span ref={ref} className={className} data-testid={testId}>
            {prefix}
            {val.toLocaleString()}
            {suffix}
        </span>
    );
}
